module.exports = __webpack_public_path__ + "static/media/b5.6c5649c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhangxinyuan/b5.mp3
// module id = hJbI
// module chunks = 0